<template>
  <svg
    id="Shop--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Shop Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M4 1c-0.42051 0 -0.79609 0.26307 -0.93979 0.65826l-1.82913 5.0301C1.0782 7.10877 1 7.55266 1 8c0 1.05294 0.37555 2.0182 1 2.769V22c0 0.5523 0.44772 1 1 1h18c0.5523 0 1 -0.4477 1 -1V10.769c0.6245 -0.7508 1 -1.71606 1 -2.769 0 -0.44734 -0.0782 -0.89123 -0.2311 -1.31164l-1.8291 -5.0301C20.7961 1.26307 20.4205 1 20 1H4Zm8 9.3333c-1.2886 0 -2.33331 -1.04464 -2.33331 -2.3333 0 -0.55228 -0.44772 -1 -1 -1 -0.55229 0 -1 0.44772 -1 1 0 1.28865 -1.04469 2.3333 -2.33336 2.3333C4.04467 10.3333 3 9.28866 3 8c0 -0.21423 0.03745 -0.42682 0.11066 -0.62815L4.70043 3H19.2996l1.5897 4.37185C20.9625 7.57318 21 7.78577 21 8c0 1.28866 -1.0447 2.3333 -2.3333 2.3333 -1.2887 0 -2.3334 -1.04464 -2.3334 -2.3333 0 -0.55228 -0.4477 -1 -1 -1 -0.5522 0 -1 0.44772 -1 1 0 1.28866 -1.0446 2.3333 -2.3333 2.3333ZM19 14h-4v7h4v-7ZM5 14h5v4H5v-4Z"
      clip-rule="evenodd"
      stroke-width="1"
    />
  </svg>
</template>
